const routes = {
  login: '/login',
  otpverification: '/otpverification',
  emailverification: '/emailverification',
  signup: '/signup',
  onboarding: '/onBoarding',
  forgotPassword: '/forgotPassword',
  changePassword: '/changePassword',



  mentorship: '/mentorship',

  network: '/network',
  survey: '/survey',
  createSurvey: '/survey/create-survey',
  test: '/test',

  RequestService: '/support/RequestService',
  Answers: '/support/Answers',
  TicketPreview: '/support/TicketPreview',
  connectSocials: '/connect-social',

  // home
  home: '/home',
  featureStory: '/home/featured-story',

  // profile
  profile: '/profile',
  profileDetails: '/profile/profile-details',
  notifcation: '/notification',
  chat: '/chat',

  // MyPortfolio
  myPortfolio: '/myPortfolio',
  fundPortfolioDetails: '/myPortfolio/fund-Portfolio-Details',
  recentReports: '/myPortfolio/recent-reports',
  engagementrSummaryDetails: '/myPortfolio/summary',

  // getInvolved
  getinvolved: '/getInvolved',

  // COE
  coe: '/service&support',


  // Deals
  deals: '/deals',
  dealsDetails: '/deals/offers',
  viewAllOffers: '/deals/offers',
  viewAllCeo: '/deals/COE',

  //support
  support: '/support',
  faqs: '/support/FAQs',
  request: '/support/Request',

  // jury portal
  juryPortal: '/GIC-Portal',
  assignedStartups: '/GIC-Portal/assigned-startups',

  // milestones and goals
  goalsAndMilestones: '/Goals-&-Milestones',
  addgoalmilestones: '/Goals-&-Milestones/add-new',
  goalsAndMilestonesData: '/Goals-&-Milestones/Details',

  // mentors
  mentors: '/mentors',
  featuredmentors: '/mentors/featuredmentors',
  mentorsdetails: '/mentors/:name',
  //! Network
  // people
  people: '/people',
  // startups
  startups: '/startups',
  // groups
  groups: '/groups',
  discoverGroups: '/groups/discover-groups',
  createGroup: '/groups/create-group',
  yourGroups: '/groups/Your-groups',

  //! participate
  // Programs
  program: '/programs',
  programdetails: '/programs/programdetails',
  //  Challenges
  challenges: '/challenges',
  // events
  events: '/events',
  eventDetail: '/events',
  hostEvent: '/events/hostevent',
  registeredEvents: '/events/registered-events',
};

export default routes;
